// 系统管理
export default {
  path: '/System',
  component: () => import('views/Layout.vue'),
  children: [
    {
      path: 'SiteManager',
      name: 'SiteManager',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '站点管理',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "SiteManager"*/ 'views/system/siteManager'),
      },
    },

    {
      path: 'AccountInManagement',
      name: 'AccountInManagement',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '账户管理',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "AccountInManagement"*/ 'views/system/accountInManagement'),
      },
    },
    {
      path: 'RoleManagement',
      name: 'RoleManagement',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '角色管理',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "RoleManagement"*/ 'views/system/roleManagement'),
      },
    },
    {
      path: 'OperationLog',
      name: 'OperationLog',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '操作日志',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "OperationLog"*/ 'views/system/operationLog'),
      },
    },
    {
      path: 'PersonalityConfiguration',
      name: 'PersonalityConfiguration',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '个性配置',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "personalConfig"*/ 'views/system/personalConfig'),
      },
    },
    {
      path: 'GatewayManager',
      name: 'GatewayManager',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '网关管理',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "GatewayManager"*/ 'views/system/gatewayManager'),
      },
    },
    {
      path: 'ClientReleaseManager',
      name: 'ClientReleaseManager',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '应用发布管理',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "ClientReleaseManager"*/ 'views/system/clientReleaseManager'),
      },
    },
    {
      path: 'DomainManager',
      name: 'DomainManager',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '租户管理',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "DomainManager"*/ 'views/system/domainManager'),
      },
    },
    {
      path: 'ConfigManager',
      name: 'ConfigManager',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '配置管理',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "ConfigManager"*/ 'views/system/configManager/index'),
      },
    },
    {
      path: 'PolicyBase',
      name: 'PolicyBase',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '策略库',
        keepAlive: true,
        // skipPermission: true,
        defaultComponent: () => import('views/system/policyBase/index.vue'),
      },
    },

    {
      path: 'ModelBase',
      name: 'ModelBase',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '物模型库',
        keepAlive: true,
        defaultComponent: () => import('views/system/modelBase/index.vue'),
      },
    },
    {
      path: 'thingModelEdit',
      name: 'thingModelEdit',
      component: () => import('@/views/webview.vue'),
      meta: {
        hide: true,
        _meauname: '物模型编辑',
        // keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "thingModelEdit"*/ 'views/system/thingModel/thingModelEdit/index'),
      },
    },

    {
      path: 'FlowManager',
      name: 'FlowManager',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '流水线管理',
        keepAlive: true,
        // skipPermission: true,
        defaultComponent: () => import('views/system/flowManager/index.vue'),
      },
    },

    {
      path: '/:pathMatch(.*)',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '系统管理404',
        defaultComponent: () => import('views/404'),
      },
    },
  ],
}
